import React, { Component } from 'react'
import { Provider } from 'mobx-react'
import { HashRouter, Route} from 'react-router-dom'
import Tapbar from './components/Tapbar'
import ScrollToTop from './components/ScrollToTop'
import Toast from './components/Toast'
// import Onsale from './components/Onsale'
// import WechatInfo from './components/WechatInfo'
// import Header from '@containers/Header'

// import UserStore from '@store/user'
// import BaseStore from '@store/base'
import TabBarStore from '@store/tabBar'
import UserInfoStore from '@store/userInfo'
import WeChatStore from '@store/weChat'


// import Home from '@pages/Home'
// import Detail from '@pages/Detail'
import ProtocolVip from '@pages/ProtocolVip'
import ProtocolAuto from '@pages/ProtocolAuto'


import Pagenormal from '@pages/Pagenormal'
import Pagesuper from '@pages/Pagesuper'
import Pagesale from '@pages/Pagesale'
import isIPhoneX from './lib/isIPhoneX'
import environment from './lib/env.js'
// 调试器 上线注视
// 添加微信推送购买逻辑上线

// require('eruda').init()

// 抽离用户信息，用户当前vip等级等逻辑，在new的时候直接请求
// const userStore = new UserStore()
// const baseStore = new BaseStore()
const tabBarStore = new TabBarStore()
const userInfoStore = new UserInfoStore()
const wechatStore = new WeChatStore()

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
    };
  }

  // 区分环境显示tab
  blockType() {
    if(environment.environment === 'wx') {
      return (<></>)
    } else if (isIPhoneX()) {
      return (<div style={{height: '86px', zIndex: 10}}/>)
    } else {
      return (<div style={{height: '2.1rem', zIndex: 10}}/>)
    }
  }
  render() {
    return (
      <Provider
      // base={baseStore}
      // user={userStore}
      tabBar={tabBarStore}
      userInfo={userInfoStore}
      weChat={wechatStore}
      >
        <HashRouter>
          <ScrollToTop>
            <div>
              <Toast/>
              {/* <WechatInfo/> */}
              <Tapbar/>
              {/* 端方法判断齐刘海，先放着 */}
              {/* 采用原有方式进行刘海屏判定 */}
              {
                this.blockType()
              }
              {/* <Onsale/> */}
              {/* <Route exact path="/" component={Home}/>
              <Route path="/detail" component={Detail}/>
              <Route path="/protocol-vip" component={ProtocolVip}/>
              */}
              {/* 采用新的方式，不区分ios或者android */}
              <Route exact path='/' component={Pagenormal}></Route>
              <Route exact path='/detail' component={Pagenormal}></Route>
              {/* 下线荣耀会员 */}
              {/* <Route path='/superMember' component={Pagesuper}></Route> */}
              <Route path='/superMember' component={Pagenormal}></Route>
              <Route path='/sale' component={Pagesale}></Route>
              <Route path="/protocol-vip" component={ProtocolVip}/>
              <Route path="/protocol-auto" component={ProtocolAuto}/>
            </div>
          </ScrollToTop>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;
